import Portfolio from './pages/Portfolio';
import './index.css';

function App() {
  return <Portfolio />;
}

export default App;
